import Api from '../api'

export default ({
  state: {
    maxPurchaseNumber: null,
    maxPurchaseChallanNumber: null,
    maxPurchaseOrderNumber: null,
    maxSalesReturnNumber: null,
    maxBatchNumber: null,
    purchaseChallanLists: [],
    purchaseInvoiceLists: [],
    purchaseOrderLists: [],
    purchaseReturnLists: [],
    inventoryInDetailList: []
  },
  mutations: {
    MAX_PURCHASE_NUMBER(state, maxPurchaseNo) {
      state.maxPurchaseNumber = maxPurchaseNo
    },
    MAX_PURCHASE_CHALLAN_NUMBER(state, maxPurchaseChallanNo) {
      state.maxPurchaseChallanNumber = maxPurchaseChallanNo
    },
    MAX_SALES_RETURN_NUMBER(state, maxSalesReturnNo) {
      state.maxSalesReturnNumber = maxSalesReturnNo
    },
    MAX_PURCHASE_ORDER_NUMBER(state, maxPurchaseOrderNo) {
      state.maxPurchaseOrderNumber = maxPurchaseOrderNo
    },
    MAX_BATCH_NUMBER(state, maxBatchNo) {
      state.maxBatchNumber = maxBatchNo
    },
    PURCHASE_CHALLAN_LIST(state, purchaseChallanList) {
      state.purchaseChallanLists = purchaseChallanList
    },
    PURCHASE_INVOICE_LIST(state, purchaseInvoiceList) {
      state.purchaseInvoiceLists = purchaseInvoiceList
    },
    PURCHASE_ORDER_LIST(state, purchaseOrderList) {
      state.purchaseOrderLists = purchaseOrderList
    },
    PURCHASE_RETURN_LIST(state, purchaseReturnList) {
      state.purchaseReturnLists = purchaseReturnList
    },
    DELETE_PURCHASE_RETURN(state, inventoryInHeaderId) {
      let purchaseReturnList = state.purchaseReturnLists.filter(a => a.id !== inventoryInHeaderId.id)
      state.purchaseReturnLists = purchaseReturnList
    },
    DELETE_PURCHASE_INVOICE(state, purInvoice) {
      let purchaseInvoiceList = state.purchaseInvoiceLists.filter(a => a.id !== purInvoice.id)
      state.purchaseInvoiceLists = purchaseInvoiceList
    },
    DELETE_PURCHASE_ORDER(state, purOrder) {
      let purchaseOrderList = state.purchaseOrderLists.filter(a => a.id !== purOrder.id)
      state.purchaseOrderLists = purchaseOrderList
    },
    DELETE_PURCHASE_CHALLAN(state, purChallan) {
      let purchaseChallanList = state.purchaseChallanLists.filter(a => a.id !== purChallan.id)
      state.purchaseChallanLists = purchaseChallanList
    },
    UPDATE_PURCHASE_CHALLAN(state, updatedPurChallan) {
      let purchaseChallan = state.purchaseChallanLists.map(so => so.id !== updatedPurChallan.id ? so : { ...so, ...updatedPurChallan })
      state.purchaseChallanLists = purchaseChallan
    },
    INVENTORY_IN_DETAIL(state, inventoryInDetail) {
      state.inventoryInDetailList = inventoryInDetail
    },
    UPDATE_PURCHASE_INVOICE(state, updatedPurchaseInv) {
      state.purchaseInvoiceLists = state.purchaseInvoiceLists.map(purchaseInv => purchaseInv.id !== updatedPurchaseInv.id ? purchaseInv : { ...purchaseInv, ...updatedPurchaseInv })
    },
    UPDATE_PURCHASE_RETURN(state, purchaseReturn) {
      state.purchaseReturnLists = state.purchaseReturnLists.map(purRetr => purRetr.id !== purchaseReturn.id ? purRetr : { ...purRetr, ...purchaseReturn })
    },
    UPDATE_PURCHASE_ORDER(state, purchaseOrder) {
      state.purchaseOrderLists = state.purchaseOrderLists.map(purOrd => purOrd.id !== purchaseOrder.id ? purOrd : { ...purOrd, ...purchaseOrder })
    }
  },
  actions: {
    async maxPurchaseOrderNo({ commit }) {
      let response = await Api.request('get', '/inventoryIn/purchaseOrderLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_PURCHASE_ORDER_NUMBER', responseValue)
      return response
    },
    async maxPurchaseBillNo({ commit }) {
      let response = await Api.request('get', '/inventoryIn/purchaseInvoiceLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_PURCHASE_NUMBER', responseValue)
      return response
    },
    async maxPurchaseChallanNumber({ commit }) {
      let response = await Api.request('get', '/inventoryIn/purchaseChallanLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_PURCHASE_CHALLAN_NUMBER', responseValue)
      return response
    },
    async maxSalesReturnNumber({ commit }) {
      let response = await Api.request('get', '/inventoryIn/salesReturnLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_SALES_RETURN_NUMBER', responseValue)
      return response
    },
    async maxBatchNo({ commit }) {
      let response = await Api.request('get', '/inventoryIn/finishedGoodsLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_BATCH_NUMBER', responseValue)
      return response
    },
    async addpurchaseOrder({ commit }, purchaseOrder) {
      let response = await Api.request('post', '/inventoryIn/purchaseOrder/' + this.state.organisationid + '/' + this.state.user.id, purchaseOrder)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_PURCHASE_ORDER', responseValue)
      }
      return response
    },
    async addfinishedGoods({ commit }, purchaseOrder) {
      let response = await Api.request('post', '/inventoryIn/finishedGoods/' + this.state.organisationid + '/' + this.state.user.id, purchaseOrder)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_FINISHED_GOODS', responseValue)
      }
      return response
    },
    async addSalesReturn({ commit }, salesReturn) {
      // // debugger
      let response = await Api.request('post', '/inventoryIn/saveSalesReturn/' + this.state.organisationid + '/' + this.state.user.id, salesReturn)
      // let responseValue = response.data.data
      // // debugger
      // if (response.data.status === 'SUCCESS') {
      //   commit('ADD_SALES_RETURN', responseValue)
      // }
      return response
    },
    async updateSalesReturn({ commit }, updateSalesReturn) {
      let response = await Api.request('put', '/inventoryIn/updatePurchase/' + updateSalesReturn.inventoryOutHeaderId + '/' + this.getters.userId, updateSalesReturn)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_RETURN', response.data.data)
      }
      return response
    },
    async addpurchaseChallan({ commit }, purchaseChallan) {
      let response = await Api.request('post', '/inventoryIn/purchaseChallan/' + this.state.organisationid + '/' + this.state.user.id, purchaseChallan)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_PURCHASE_CHALLAN', responseValue)
      }
      return response
    },
    async addPurchaseInvoice({ commit }, purchaseInvoice) {
      let response = await Api.request('post', '/inventoryIn/purchaseInvoice/' + this.state.organisationid + '/' + this.state.user.id, purchaseInvoice)
      let responseValue = response.data.data
      if (response.data.data === 'SUCCESS') {
        commit('ADD_PURCHASE_INVOICE', responseValue)
      }
      return response
    },
    async addPurchaseDairyInvoice({ commit }, purchaseInvoice) {
      let response = await Api.request('post', '/inventoryIn/purchaseInvoiceDairy/' + this.state.organisationid + '/' + this.state.user.id, purchaseInvoice, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let responseValue = response.data.data
      if (response.data.data === 'SUCCESS') {
        commit('ADD_PURCHASE_INVOICE', responseValue)
      }
      return response
    },
    async updatePurchaseOrder({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/inventoryIn/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('UPDATE_PURCHASE_ORDER', response.data.data)
      return response
    },
    async updatePurchaseChallan({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/inventoryIn/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('UPDATE_PURCHASE_CHALLAN', response.data.data)
      return response
    },
    async updatePurchaseInvoice({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/inventoryIn/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      commit('UPDATE_PURCHASE_INVOICE', response.data.data)
      return response
    },
    async updatePurchaseReturn({ commit }, updatePurchaseInv) {
      let response = await Api.request('put', '/inventoryIn/updatePurchase/' + updatePurchaseInv.inventoryHeaderId + '/' + this.state.user.id, updatePurchaseInv)
      // // debugger
      commit('UPDATE_PURCHASE_RETURN', response.data.data)
      return response
    },
    async loadpurchaseOrderLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/purchaseOrder/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('PURCHASE_ORDER_LIST', responseValue)
      return response
    },
    async loadpurchaseInvoiceLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/purchaseInvoice/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('PURCHASE_INVOICE_LIST', responseValue)
      return response
    },
    async loadpurchaseChallanLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/purchaseChallan/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('PURCHASE_CHALLAN_LIST', responseValue)
      return response
    },
    async deletePurchaseOrder({ commit }, deleteRea) {
      let response = await Api.request('delete', '/inventoryIn/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('DELETE_PURCHASE_ORDER', deletePurchase)
      return response
    },
    async deletePurchaseChallan({ commit }, deleteRea) {
      let response = await Api.request('delete', '/inventoryIn/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('DELETE_PURCHASE_CHALLAN', deletePurchase)
      return response
    },
    async deletePurchaseInvoice({ commit }, deleteRea) {
      let response = await Api.request('delete', '/inventoryIn/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('DELETE_PURCHASE_INVOICE', deletePurchase)
      return response
    },
    async deletePurchaseReturn({ commit }, deleteRea) {
      let response = await Api.request('delete', '/inventoryIn/deletePurchase/' + deleteRea.inventoryInHeaderId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletePurchase = response.data.data
      commit('DELETE_PURCHASE_RETURN', deletePurchase)
      return response
    },
    async loadInventoryDetail({ commit }, id) {
      let response = await Api.request('get', '/inventoryInReport/inventoryInDetail/' + this.getters.organisationId + '/' + this.state.user.id + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('INVENTORY_IN_DETAIL', response.data.data)
      }
      return response
    },
    async loadPurchaseReturnLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/purchaseReturn/' + this.getters.organisationId + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('PURCHASE_RETURN_LIST', responseValue)
      return response
    },
    async exportFileData({ commit }, data) {
      let response = await Api.request('get', '/inventoryIn/excelReport/' + this.getters.organisationId + '/' + this.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/purchaseOrder')
      return response
    },
    async extraExpensesPurchaseList({ commit }, inventoryHeaderId) {
      let response = await Api.request('get', '/inventoryInReport/extraExpensesList/' + inventoryHeaderId + '/' + 'purchaseInvoice')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async purchaseBillNumber({ commit }) {
      let response = await Api.request('get', '/inventoryIn/billNumber/' + this.getters.organisationId + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadOrderIdList({ commit }) {
      let response = await Api.request('get', '/inventoryIn/orderNumber/' + this.getters.organisationId + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async challanIdList({ commit }) {
      let response = await Api.request('get', '/inventoryIn/challanNumbers/' + this.getters.organisationId + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async inventoryDetailsByBillNo({ commit }, billNo) {
      let response = await Api.request('get', '/inventoryInReport/purchaseDetailsByBillNo/' + billNo + '/' + this.getters.organisationId + '/' + this.getters.userId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async purchaseReturnBillWise({ commit }, returnData) {
      let response = await Api.request('post', '/inventoryOut/purchaseReturnBillWise/' + returnData.inventoryHeaderId + '/' + this.getters.organisationId + '/' + this.getters.userId, returnData)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async addPrint({ commit }, prinTData) {
      let response = await Api.request('post', '/fileDownload/savePrintPos/' + this.state.organisationid + '/' + this.state.user.id, prinTData)
      let responseValue = response.data.data
      if (response.data.data === 'SUCCESS') {
        commit('ADD_PRINT', responseValue)
      }
      return response
    },
    async loadDataWithOrderId({commit}, orderId) {
      let response = await Api.request('get', '/inventoryInReport/purchaseDetailsByOrderNo/' + orderId + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDataWithPurchaseChallanNo({commit}, challanNo) {
      let response = await Api.request('get', '/inventoryInReport/purchaseDetailsByChallanNo/' + challanNo + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.statue === 'SUCCESS') {
        return response
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/purchase.js